module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-visit-0e4af002356259b3b508ab13b4328a28.svg&quot;;"